import React from 'react';

export function EmptyState({
  icon,
  title,
  description,
  action,
  compact = false
}: {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  compact?: boolean;
}) {
  return (
    <div className={`emptyStateRich${compact ? ' is-compact' : ''}`}>
      {icon ? <span className="emptyStateIcon">{icon}</span> : null}
      <strong className="emptyStateTitle">{title}</strong>
      {description ? <span className="emptyStateDesc">{description}</span> : null}
      {action ? <div className="emptyStateAction">{action}</div> : null}
    </div>
  );
}
